import { RATING, API_URL, API_KEY } from '../configs/global';

export const FETCH_RATING = 'FETCH_RATING';

export const fetchRating = (id) => {

  const url = `${API_URL}/list-trip-ratings-v1/${id}?api_key=${API_KEY}`;

  if (!RATING.SHOW || !RATING.AVERAGE) return { payload: { 'rating' : 0, 'total' : null }, type: FETCH_RATING }

  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(response => dispatch({
        type: FETCH_RATING,
        payload: response
      }))
      .catch(error => console.log(error))
  } 

}


// WEBPACK FOOTER //
// ./src/actions/RatingAction.js